import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Row, Col, Input } from 'reactstrap';
import ClipLoader from 'react-spinners/ClipLoader';
import { connect } from 'react-redux';
import apis from './../../../../Api';

export function CompanyCoursesModal(props){
  const { isOpen, toggle, company, onOpenDetails, onBack, translate = {} } = props;
  const [loading, setLoading] = useState(false);
  const [courseDetails, setCourseDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setSearchTerm('');
      setCourseDetails([]);
      if (!company || !company.id) return;
      setLoading(true);
      try {
        let rows = [];
        try {
          const rpt = await apis.getCoursesUnitsReport({ company: company.id });
          if (rpt && Array.isArray(rpt.data) && rpt.data.length > 0) rows = rpt.data;
          else {
            const classroomsResp = await apis.getAllClassRoomCompanyWithCounts(company.id);
            const classrooms = (classroomsResp && Array.isArray(classroomsResp.data)) ? classroomsResp.data : [];
            const courseMap = {};
            for (let i = 0; i < classrooms.length; i++) {
              const classroom = classrooms[i];
              const cid = classroom.course;
              if (!courseMap[cid]) courseMap[cid] = { id: cid, name: '', classCount: 0, studentCount: 0, activeClassCount: 0, classes: [] };
              courseMap[cid].classes.push(classroom);
              courseMap[cid].classCount++;
              const studentsInClass = Number(classroom.countStudents || classroom.countParticipants || classroom.count || 0);
              courseMap[cid].studentCount += studentsInClass;
              const now = new Date();
              const openingDate = new Date(classroom.openingDate);
              const closingDate = new Date(classroom.closingDate);
              if (openingDate <= now && now <= closingDate) courseMap[cid].activeClassCount++;
              if ((i % 200) === 0) await new Promise(r => setTimeout(r, 0));
            }
            rows = Object.values(courseMap).map(r => ({ course: r.id, courseName: r.name, classCount: r.classCount, activeClassCount: r.activeClassCount, studentsTotal: r.studentCount, classes: r.classes }));
          }
        } catch (e) {
          console.error('Erro ao montar lista de cursos da unidade:', e);
        }

        let nameMap = {};
        try {
          const allCoursesResp = await apis.getAllcourses();
          if (allCoursesResp && Array.isArray(allCoursesResp.data)) {
            allCoursesResp.data.forEach(c => { nameMap[String(c.id)] = c.name; });
          }
        } catch (e) {}

        const details = (rows || []).map(r => ({
          id: r.course,
          name: r.courseName || r.course_name || nameMap[String(r.course)] || '',
          classCount: Number(r.classCount || r.class_count || 0),
          studentCount: Number(r.studentsTotal || r.students_total || r.students || 0),
          activeClassCount: Number(r.activeClassCount || r.active_class_count || 0),
          classes: Array.isArray(r.classes) ? r.classes : [],
          companies: r.companies || []
        }));

        details.forEach(cd => { if (!cd.name) cd.name = `Curso #${cd.id}`; });
        if (mounted) setCourseDetails(details);
      } catch (err) {
        console.error('Erro ao carregar cursos da unidade:', err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (isOpen) load();
    return () => { mounted = false; };
  }, [isOpen, company]);

  return (
    <Modal
      className="modal-dialog-centered"
      size="xl"
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxWidth: '90%' }}
    >
      <div className="modal-header">
        <h5 className="modal-title">{translate['cursos_ministrados'] || 'Cursos Ministrados'}</h5>
        <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={toggle}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center py-4">
            <ClipLoader size={40} color="#5e72e4" loading={true} />
            <p className="mt-3">{translate['carregando_cursos_unidade'] || 'Carregando cursos da unidade...'}</p>
          </div>
        ) : courseDetails && courseDetails.length > 0 ? (
          <div className="course-list">
            <Row className="mb-3">
                <Col>
                <Input
                  type="text"
                  placeholder={translate['buscar_curso'] || 'Buscar curso...'}
                  className="form-control-sm"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value || "")}
                />
              </Col>
            </Row>

            <div className="table-responsive">
              <Table className="align-items-center table-hover">
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: '40%' }}>{translate['curso'] || 'Curso'}</th>
                    <th style={{ width: '15%' }}>{translate['turmas'] || 'Turmas'}</th>
                    <th style={{ width: '15%' }}>{translate['turmas_ativas'] || 'Turmas Ativas'}</th>
                    <th style={{ width: '15%' }}>{translate['alunos'] || 'Alunos'}</th>
                    <th style={{ width: '15%' }}>{translate['acoes'] || 'Ações'}</th>
                  </tr>
                </thead>
                <tbody>
                  {courseDetails
                    .filter(course => {
                      const term = (searchTerm || "").trim().toLowerCase();
                      if (!term) return true;
                      const name = (course.name || (`Curso #${course.id}`)).toString().toLowerCase();
                      return name.includes(term);
                    })
                    .map(course => (
                      <tr key={`course-${course.id}`} className="course-item" data-course-name={course.name || `Curso #${course.id}`}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div>
                              <i className="fas fa-book text-primary mr-3" style={{fontSize: "1.5rem"}}></i>
                            </div>
                            <div>
                              <h5 className="mb-0">{course.name || `Curso #${course.id}`}</h5>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">{course.classCount}</td>
                        <td className="text-center">{course.activeClassCount}</td>
                        <td className="text-center">{course.studentCount}</td>
                        <td>
                          <Button color="primary" size="sm" onClick={() => {
                            const num = parseInt(course.id, 10);
                            if (Number.isNaN(num)) return; 
                            onOpenDetails(num, course.name);
                          }}>
                            <i className="fas fa-list-alt mr-1"></i> {translate['detalhes'] || 'Detalhes'}
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
            <div className="text-center py-5">
            <div className="mb-3"><i className="fas fa-book text-muted" style={{fontSize: "3rem"}}></i></div>
            <h4 className="text-muted">{translate['nenhum_curso_unidade'] || 'Nenhum curso encontrado para esta unidade'}</h4>
          </div>
        )}
      </div>
      <div className="modal-footer d-flex justify-content-between w-100">
        <div>{onBack && (<Button color="link" onClick={onBack}><i className="fas fa-arrow-left mr-1"></i> {translate['voltar'] || 'Voltar'}</Button>)}</div>
        <div><Button color="secondary" onClick={toggle}>{translate['fechar'] || 'Fechar'}</Button></div>
      </div>
    </Modal>
  );
}

export default connect(state => ({ translate: state.translate }))(CompanyCoursesModal);
